import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type {
  ListingsAPIAndFilter,
  ListingsAPIOrFilter,
} from '../../common/types/ListingsAPIFilter';
import type {
  EventType,
  Product,
  RecommendationsRequestBody,
} from '../types/RecommendationsRequestBody';

export class RecommendationsRequestBuilder {
  private request: RecommendationsRequestBody = {
    currencyCode: 'GBP',
    eventType: 'detail-page-view',
    pageSize: 10,
  };

  currency(code: CurrencyCode): this {
    this.request.currencyCode = code;
    return this;
  }

  filter(filter: ListingsAPIAndFilter | ListingsAPIOrFilter): this {
    if (this.request.filter && Object.keys(this.request.filter).length > 0) {
      throw new Error('a filter is already set on the request');
    }
    this.request.filter = filter;
    return this;
  }

  pageSize(size: number): this {
    this.request.pageSize = size;
    return this;
  }

  products(products: Product[]): this {
    this.request.products = products;
    return this;
  }

  eventType(eventType: EventType): this {
    this.request.eventType = eventType;
    return this;
  }

  build(): RecommendationsRequestBody {
    if (this.request.products && this.request.products.length < 1) {
      throw new Error(
        'No products specified in the products array. Please add products to the recommendations request by calling `.products` on the builder class.',
      );
    }

    return structuredClone(this.request);
  }
}
